import type { Vector3, Vector3Like } from 'three'

export const OPACITY_SELECTED_PROCEDURE = 1
export const OPACITY_NON_SELECTED_PROCEDURE = 0
export const OPACITY_PREVIEW = 0.3

export const getProcedureOpacity = (
  isFromSelectedProcedure: boolean,
  isPrinting: boolean = false,
  isPreview: boolean = false,
  inactiveProcedureOpacity: number = OPACITY_NON_SELECTED_PROCEDURE,
): number => {
  if (isPreview) {
    return OPACITY_PREVIEW
  }
  if (isPrinting) {
    return OPACITY_SELECTED_PROCEDURE
  }
  return isFromSelectedProcedure ? OPACITY_SELECTED_PROCEDURE : inactiveProcedureOpacity
}

export const vector3ToVector3Like = (vector3: Vector3): Vector3Like => {
  return {
    x: vector3.x,
    y: vector3.y,
    z: vector3.z,
  }
}
